import SvgIcon from '@mui/material/SvgIcon'
const CheckIcon = props => (
  <SvgIcon fill="#ffffff" stroke="none" viewBox="0 0 24 24" {...props}>
    <path d="M9,16.2L4.8,12l-1.4,1.4L9,19L21,7l-1.4-1.4L9,16.2z" />
  </SvgIcon>
)
export default CheckIcon
